import api from './client'

// One unified plan record across all three dock backends (AutoAgent / Claude /
// Codex), persisted server-side under the project's .twasta_plans/ directory.
export interface AgentPlan {
  id: string
  project: string
  backend: 'autoagent' | 'claude' | 'codex' | 'opencode'
  title: string
  kind: string
  status: 'running' | 'paused' | 'awaiting_review' | 'completed' | 'error'
  description?: string
  created_at: number
  updated_at: number
  todos?: Array<Record<string, unknown>>
  phases?: Array<Record<string, unknown>>
  originating_prompt?: string
  resume_ref?: Record<string, unknown>
  depends_on?: string[]
}

export async function listPlans(project: string): Promise<AgentPlan[]> {
  const { data } = await api.get(`/agentplans/${encodeURIComponent(project)}`)
  return data.plans || []
}

export async function getPlan(project: string, planId: string): Promise<AgentPlan> {
  const { data } = await api.get(
    `/agentplans/${encodeURIComponent(project)}/${encodeURIComponent(planId)}`,
  )
  return data
}

// Deletes the plan from EVERY store that holds it (registry mirror, the
// AutoAgent state file, and any live in-memory session) — deleting only the
// mirror is undone by the next state save. ``force`` also deletes a plan that
// is genuinely still executing.
export async function deletePlan(
  project: string, planId: string, force = false,
): Promise<void> {
  await api.delete(
    `/agentplans/${encodeURIComponent(project)}/${encodeURIComponent(planId)}`,
    { params: force ? { force: true } : undefined },
  )
}
